/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2022 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import { merge } from "@keeex/js-utils/lib/uint8array.js";
/**
 * Dummy implementation that falls back to using digestImmediate()
 */
export default class ChunkDigest {
    algorithm;
    digestImmediate;
    buffer;
    constructor(algorithm, digestImmediateFunc) {
        this.algorithm = algorithm;
        this.buffer = new Uint8Array();
        this.digestImmediate = digestImmediateFunc;
    }
    /**
     * Append an input chunk of data
     */
    update(bytes) {
        this.buffer = merge([this.buffer, bytes]);
        return Promise.resolve();
    }
    /**
     * Optionnaly append data and return the result of the digest
     */
    async digest(data) {
        if (data) {
            await this.update(data);
        }
        return this.digestImmediate(this.algorithm, this.buffer);
    }
}
